import { LegalShell, Section, UPDATED } from "@/pages/Legal";

export default function Disclaimer() {
  return (
    <LegalShell eyebrow="LEGAL" title="Disclaimer" updated={UPDATED} testid="disclaimer-page"
      seo={{ title: "Disclaimer", description: "Important limitations of Studivault's AI-generated study material, exam preparation content and user-shared packs.", path: "/disclaimer" }}>
      <p>Studivault (studivault.com) is operated by <strong>Bloc Metric</strong>, India. Please read this disclaimer carefully.</p>

      <Section n={1} title="AI-generated content">
        Notes, flashcards, quizzes, mock exams, grading, Feynman feedback and tutor answers are generated
        automatically by third-party AI models (DeepSeek and Google Gemini). They can contain errors,
        omissions, outdated information or "hallucinated" facts. Always verify important information against
        your textbooks, teachers or other authoritative sources.
      </Section>

      <Section n={2} title="Educational use only">
        The Service is a study aid. It is not professional, medical, legal, financial or career advice, and is
        not a substitute for instruction from qualified teachers.
      </Section>

      <Section n={3} title="No guarantee of results">
        We do not guarantee any particular exam score, rank, admission or academic outcome. Exam names (such as
        JEE, NEET or UPSC) are used only to describe study topics; Studivault is not affiliated with or endorsed by
        any examining body or institution.
      </Section>

      <Section n={4} title="User and demo content">
        Public study packs are created by users or as demo samples and are not reviewed for accuracy by us.
        Views expressed in user content are those of their authors. Leaderboards and the marketplace may include
        demo accounts created for demonstration.
      </Section>

      <Section n={5} title="Availability and external links">
        The Service may be interrupted for maintenance or reasons beyond our control. Links to third-party sites
        (such as YouTube) are provided for convenience; we are not responsible for their content.
      </Section>

      <Section n={6} title="Contact">
        Report an error or concern: <a href="mailto:shaurya@sanghviinfo.com" className="text-[#B8A4FF] hover:underline">shaurya@sanghviinfo.com</a>
      </Section>
    </LegalShell>
  );
}
